document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.ir-risk');
  const badge = document.querySelector('.ir-risk__badge');

  if (!section) return;

  let badgeAnimated = false;

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          section.classList.add('is-visible');

          if (badge && !badgeAnimated) {
            badgeAnimated = true;

            const finalNumber = parseInt(
              badge.textContent.replace(/\D/g, ''),
              10
            );

            badge.textContent = '+0 REVIEWS';

            let startTime = performance.now();
            const duration = 900;

            const animate = time => {
              const progress = Math.min((time - startTime) / duration, 1);
              const current = Math.floor(progress * finalNumber);
              badge.textContent = `+${current.toLocaleString()} REVIEWS`;
              if (progress < 1) requestAnimationFrame(animate);
            };

            requestAnimationFrame(animate);
            badge.classList.add('is-visible');
          }
        }
      });
    },
    { threshold: 0.4 }
  );

  observer.observe(section);
});
